angular
  .module('app')
  .component('bookingEngine', {
    templateUrl: 'app/components/bookingEngine/BookingEngine.html',
    controller: BookingEngine,
    bindings: {
      hotelConfig: '<',
      bookingEngineConfig: '<',
      categoriesList: '<',
      roomGroupCategoryFiltersList: '<',
      customerCss: '<'
    }
  });

// eslint-disable-next-line
function BookingEngine(Params, Currency, Categories, RoomGroupCategoryFilters, ConfigHotel, ConfigBookingEngine, $state, $translate, $rootScope, $window, $document) {
  var $this = this;
  $this.Params = Params;
  $this.Currency = Currency;
  $this.Categories = Categories;
  $this.RoomGroupCategoryFilters = RoomGroupCategoryFilters;
  $this.ConfigHotel = ConfigHotel;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $rootScope.ConfigBookingEngine = ConfigBookingEngine; // for google tags in index.html
  $this.window = $window;
  $this.document = $document;
  $this.$state = $state;
  $this.$translate = $translate;
}

BookingEngine.prototype = {
  $onInit: function () {
    if (!this.isValidConfiguration()) {
      this.$state.go('serverErrors', {}, {location: false});
      return;
    }
    this.ConfigHotel.setConfig(this.hotelConfig);
    this.setRoomGroupCategoryFilters();
    this.setCategories();
    this.setHotelTime();
    this.ConfigBookingEngine.setConfig(this.bookingEngineConfig);
    this.isEnabled = this.ConfigBookingEngine.isBookingEngineEnabled();
    var finalBookingAcceptanceTime = this.ConfigHotel.getFinalBookingAcceptanceTime();
    this.Params.setMinCheckInTime(finalBookingAcceptanceTime);
    var availableLanguages = this.ConfigBookingEngine.getAvailableLanguages();
    this.Params.setAvailableLanguages(availableLanguages);

    this.userHash = this.getUserHash();
    this.hotelId = this.getHotelId();
    this.language = this.getLanguage();

    /* eslint-disable camelcase */
    this.Currency.setCurrency(this.hotelConfig.currency);
    this.Currency.setCurrencyPrefix(this.hotelConfig.currency_prefix);
    this.Currency.setCurrencySuffix(this.hotelConfig.currency_suffix);
    /* eslint-enable camelcase */

    /* google tag manager */
    var gtmId = this.ConfigBookingEngine.getGoogleTagHeader();

    const doc = this.document[0];
    const body = doc.body;

    // 1. Wstawiamy skrypt konfiguracyjny ZANIM załadujemy gtag.js
    const configScript = doc.createElement('script');
    configScript.type = 'text/javascript';
    configScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('consent', 'default', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted',
        'functionality_storage': 'granted',
        'personalization_storage': 'granted',
        'security_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted'
      });
      dataLayer.push({
        event: 'cookie_consent_default',
        cookie_consent: {
          'ad_storage': 'granted',
          'analytics_storage': 'granted',
          'functionality_storage': 'granted',
          'personalization_storage': 'granted',
          'security_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted'
        }
      });
    `;
    body.appendChild(configScript);

    // 2. Dopiero teraz dodajemy gtag.js (asynchroniczny)
    const gtagScript = doc.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtmId;
    body.appendChild(gtagScript);

    // 3. Konfiguracja gtag.js (po consent)
    const initScript = doc.createElement('script');
    initScript.type = 'text/javascript';
    initScript.text = `
      gtag('js', new Date());
      gtag('set', {
        'cookie_flags': 'SameSite=None; Secure',
        'cookie_update': false
      });
      gtag('config', '${gtmId}');
    `;
    body.appendChild(initScript);

    var bodyGtm =
      '<!-- Google Tag Manager (noscript) -->' +
      '<noscript>' +
      '<iframe src="https://www.googletagmanager.com/ns.html?id=' +
      gtmId +
      '" height="0" width="0" style="display:none;visibility:hidden"></iframe>' +
      '</noscript>' +
      '<!-- End Google Tag Manager (noscript) -->';

    angular.element(bodyGtm).prependTo(angular.element('body'));

    var consent = this.Params.getConsent();

    if (consent) {
      const updateScript = doc.createElement('script');
      updateScript.type = 'text/javascript';
      updateScript.text = `
        gtag('consent', 'update', {
        'ad_storage': '${consent.ad_storage}',
        'analytics_storage': '${consent.analytics_storage}',
        'functionality_storage': '${consent.functionality_storage}',
        'personalization_storage': '${consent.personalization_storage}',
        'security_storage': '${consent.security_storage}',
        'ad_user_data': '${consent.ad_user_data}',
        'ad_personalization': '${consent.ad_personalization}'
      });
      dataLayer.push({
        event: 'cookie_consent_update',
        cookie_consent: {
        'ad_storage': '${consent.ad_storage}',
        'analytics_storage': '${consent.analytics_storage}',
        'functionality_storage': '${consent.functionality_storage}',
        'personalization_storage': '${consent.personalization_storage}',
        'security_storage': '${consent.security_storage}',
        'ad_user_data': '${consent.ad_user_data}',
        'ad_personalization': '${consent.ad_personalization}'
        }
      });
      `;
      body.appendChild(updateScript);
    }
  },

  isValidConfiguration: function () {
    var isValidHotelConfig = angular.isDefined(this.hotelConfig) && this.hotelConfig !== null;
    var isValidBookingEngineConfig = angular.isDefined(this.bookingEngineConfig) && this.bookingEngineConfig !== null;
    var isValidUserHash = this.getUserHash() !== null;
    var isValidHotelId = this.getHotelId() !== null;
    return isValidHotelConfig && isValidBookingEngineConfig && isValidUserHash && isValidHotelId;
  },

  setHotelTime: function () {
    var ConfigHotel = this.ConfigHotel;
    moment.now = function () {
      return ConfigHotel.getTime();
    };
  },

  setCategories: function () {
    if (!angular.isArray(this.categoriesList)) {
      this.categoriesList = [];
    }
    this.categoriesList.unshift({id: null, code: this.$translate.instant('offers.panel.categories.DEFAULT_FILTER')});
    this.Categories.setCategories(this.categoriesList);
  },

  setRoomGroupCategoryFilters: function () {
    if (!angular.isArray(this.roomGroupCategoryFiltersList)) {
      this.roomGroupCategoryFiltersList = [];
    }
    this.roomGroupCategoryFiltersList.unshift({id: null, name: this.$translate.instant('offers.panel.categories.DEFAULT_FILTER')});
    this.RoomGroupCategoryFilters.setRoomGroupCategoryFilters(this.roomGroupCategoryFiltersList);
  },

  getUserHash: function () {
    return this.Params.getUserHash();
  },

  getHotelId: function () {
    return this.Params.getHotelId();
  },

  getLanguage: function () {
    return this.Params.getLanguage();
  }
};
